import React, { useState, useEffect } from 'react';

const KEY = 'ps_cookie_consent';

const CookieBanner = () => {
    const [show, setShow] = useState(false);
    useEffect(() => {
        let v = null;
        try { v = localStorage.getItem(KEY); } catch (e) { }
        if (!v) setShow(true);
    }, []);
    const accept = () => {
        try { localStorage.setItem(KEY, '1'); } catch (e) { }
        setShow(false);
        window.dispatchEvent(new CustomEvent('cookie-consent'));
        // Загружаем Яндекс.Метрику только после согласия (152-ФЗ + соответствие PrivacyPage)
        if (typeof window.__psMetrikaInit === 'function') {
            window.__psMetrikaInit();
        }
    };
    const decline = () => {
        try { localStorage.setItem(KEY, '0'); } catch (e) { }
        setShow(false);
    };
    if (!show) return null;
    return (
        <div className="fixed bottom-0 inset-x-0 z-[70] bg-[#1C1917] text-white text-sm p-4">
            <div className="container mx-auto flex flex-col sm:flex-row gap-3 items-center justify-between">
                <p>
                    Мы используем cookie и Яндекс.Метрику для аналитики. Продолжая, вы соглашаетесь с{' '}
                    <a href="/privacy" className="underline text-[#9DB49B]">политикой обработки персональных данных</a>.
                </p>
                <div className="flex gap-2 shrink-0">
                    <button onClick={accept} className="btn-primary">Принять</button>
                    <button onClick={decline} className="btn-outline !text-white !border-white/40">Отклонить</button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;